import React, { Fragment } from 'react';
import { SortableElement } from 'react-sortable-hoc';

const CardDraggable = SortableElement(({ children }) => <Fragment>{children}</Fragment>);

CardDraggable.displayName = 'CardDraggable';

export default CardDraggable;
